import { useWarehouse } from "../Providers/WarehouseProvider"

const useWarehouseOperations = () => {
    const { warehouses, setSelectedWarehouse, selectedWarehouse } = useWarehouse()

    const findSelectedWarehouseName = (whId) => {
        const foundWarehouse = warehouses.find(w => w.id === whId)
        if (!foundWarehouse) {
            return ''
        }
        if (!selectedWarehouse) {
            setSelectedWarehouse(foundWarehouse)
        }
        return `${foundWarehouse.name}`
    }

    return { findSelectedWarehouseName }
}

export default useWarehouseOperations